// Types
import { RootState } from 'types/RootState.types';

// Config
import { isAndroidApp, isApps, isCustomerApp, isWeb, getPlatformType } from './appReducer';

export const getAppApplicationTypeSelector = (state: RootState) => state.app?.applicationType;
export const getAuth0HealthCheckLoadingSelector = (state: RootState) => state.app?.auth0HealthCheckLoading || false;
export const getAppGooglePayStubsEnabledSelector = (state: RootState) => state.app?.googlePayStubsEnabled || false;
export const getIsExpressCheckoutSelector = (state: RootState) => state.app?.isExpressCheckout || false;
export const getAppIsLoadingSelector = (state: RootState) => state.app?.isLoading ?? false;
export const getAppIsLoginRequired = (state: RootState) => state.app?.isLoginRequired ?? false;
export const getLeaveCheckoutModalBaseRoutePathSelector = (state: RootState) =>
  state.app?.leaveCheckoutModalBaseRoutePath || '';
export const getLoadingLazyComponentSelector = (state: RootState) => state.app?.loadingLazyComponent || '';
export const getAppOrderCompleteSelector = (state: RootState) => state.app?.orderComplete || false;
export const getAppScrollToPartnershipDiscountToggleSelector = (state: RootState) =>
  state.app?.scrollToPartnershipDiscountToggle || false;
export const getAppScrollToDeliveryDetailsSelector = (state: RootState) => state.app?.scrollToDeliveryDetails || false;
export const getSessionExpiredAnnouncedSelector = (state: RootState) => state.app?.sessionExpiredAnnounced || false;
export const getSessionExpiringAnnouncedSelector = (state: RootState) => state.app?.sessionExpiringAnnounced || false;
export const getAppSessionExpiredSelector = (state: RootState) => state.app?.sessionExpired || false;
export const getAppShowDisableSiteSpinnerSelector = (state: RootState) => state.app?.showDisableSiteSpinner ?? true;
export const getShowLeaveCheckoutSelector = (state: RootState) => state.app?.showLeaveCheckout || false;
export const getShowSessionEndedModalSelector = (state: RootState) => state.app?.showSessionEndedModal || false;
export const getAppPosCreditSessionExpiredSelector = (state: RootState) => state.app?.posCreditSessionExpired || false;
export const getAppSubmitOrderTimeoutSelector = (state: RootState) => state.app?.submitOrderTimeout || false;
export const getAppShowEmptyBasketNotificationSelector = (state: RootState) =>
  state.app?.showEmptyBasketNotification || false;
export const getPageNotFoundSelector = (state: RootState) => state.app?.pageNotFound || false;

export const getIsAndroidApplicationSelector = (state: RootState) => isAndroidApp(state);
export const getIsPlatformTypeSelector = (state: RootState) => getPlatformType(state);
export const getIsApplicationSelector = (state: RootState) => isApps(state);
export const getIsCustomerAppSelector = (state: RootState) => isCustomerApp(state);
export const getIsWebSelector = (state: RootState) => isWeb(state);

export const getAppShowExpressPayments = (state: RootState) => state.app?.showExpressPayments || false;
export const getAppShopsToShowSelector = (state: RootState) => state.app?.shopsToShow;
export const getSessionRefreshAPICallActive = (state: RootState) => state.app?.sessionRefreshAPICallActive || false;

export const getHasToastBeenShown = (state: RootState) => state.app?.hasToastBeenShown || false;

export const getAppDefaultGiftMessageValueFormSelector = (state: RootState, formId: string) =>
  state.app?.defaultGiftMessageValue?.[formId];

export const getIsGiftReceiptSelectedSelector = (state: RootState, formId: string) =>
  state.app?.isGiftReceiptSelected?.[formId];

export const getIsApplePayExpressEnabled = (state: RootState) => state.app?.isApplePayExpressEnabled || false;
export const getIsPayPalPayExpressEnabled = (state: RootState) => state.app?.isPayPalPayExpressEnabled || false;
export const getThresholdBarShownSelector = (state: RootState) => state.app?.thresholdBarShown || false;
export const getAppIsInvalidPartnerDiscountSelector = (state: RootState) =>
  state.app?.isInvalidPartnerDiscount || false;
export const getAppLoadingMessageSelector = (state: RootState) => state.app?.loadingMessage;
export const getAppOrderConfirmationPageSuccessSelector = (state: RootState) =>
  state.app?.orderConfirmationPageSuccess || false;
export const getAppShowConnectivityErrorModalSelector = (state: RootState) =>
  state.app?.showConnectivityErrorModal || false;
export const getAppShowLeaveCheckoutSelector = (state: RootState) => state.app?.showLeaveCheckout || false;
export const getAppThemeSelector = (state: RootState) => state.app?.theme;
